<mat-label class="select-label content-label" [ngClass]="config.class">{{config.label}}</mat-label>